import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-md-6 col-xxl-4" }
const _hoisted_2 = { class: "card-body d-flex flex-center flex-column p-9" }
const _hoisted_3 = {
  key: 0,
  class: "symbol symbol-65px symbol-circle mb-5"
}
const _hoisted_4 = {
  key: 0,
  class: "bg-success position-absolute rounded-circle translate-middle start-100 top-100 border border-4 border-white h-15px w-15px ms-n3 mt-n3"
}
const _hoisted_5 = {
  key: 1,
  class: "symbol symbol-65px symbol-circle mb-5"
}
const _hoisted_6 = {
  key: 0,
  class: "bg-success position-absolute rounded-circle translate-middle start-100 top-100 border border-4 border-white h-15px w-15px ms-n3 mt-n3"
}
const _hoisted_7 = {
  href: "#",
  class: "fs-4 text-gray-800 text-hover-primary fw-bolder mb-0"
}
const _hoisted_8 = { class: "fw-bold text-gray-400 mb-6" }
const _hoisted_9 = { class: "d-flex flex-center flex-wrap mb-5" }
const _hoisted_10 = { class: "border border-dashed rounded min-w-125px py-3 px-4 mx-3 mb-3" }
const _hoisted_11 = { class: "fs-6 fw-bolder text-gray-700" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "fw-bold text-gray-400" }, "Avg. Earnings", -1)
const _hoisted_13 = { class: "border border-dashed rounded min-w-125px py-3 px-4 mx-3 mb-3" }
const _hoisted_14 = { class: "fs-6 fw-bolder text-gray-700" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "fw-bold text-gray-400" }, "Total Sales", -1)
const _hoisted_16 = {
  key: 2,
  href: "#",
  class: "btn btn-sm btn-light-primary"
}
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Connected ")
const _hoisted_19 = {
  key: 3,
  href: "#",
  class: "btn btn-sm btn-light"
}
const _hoisted_20 = { class: "svg-icon svg-icon-3" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Connect ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["card", _ctx.cardClasses]
    }, [
      _createVNode("div", _hoisted_2, [
        (_ctx.avatar)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("img", {
                src: _ctx.avatar,
                alt: "image"
              }, null, 8, ["src"]),
              (_ctx.online)
                ? (_openBlock(), _createBlock("div", _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("span", {
                class: [`text-${_ctx.color} bg-light-${_ctx.color}`, "symbol-label fs-2x fw-bold"]
              }, _toDisplayString(_ctx.initials), 3),
              (_ctx.online)
                ? (_openBlock(), _createBlock("div", _hoisted_6))
                : _createCommentVNode("", true)
            ])),
        _createVNode("a", _hoisted_7, _toDisplayString(_ctx.name), 1),
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.position), 1),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.avgEarnings), 1),
            _hoisted_12
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.totalSales), 1),
            _hoisted_15
          ])
        ]),
        (_ctx.connected)
          ? (_openBlock(), _createBlock("a", _hoisted_16, [
              _createVNode("span", _hoisted_17, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Double-check.svg" })
              ]),
              _hoisted_18
            ]))
          : (_openBlock(), _createBlock("a", _hoisted_19, [
              _createVNode("span", _hoisted_20, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Add-user.svg" })
              ]),
              _hoisted_21
            ]))
      ])
    ], 2)
  ]))
}